import { Component, OnInit, ViewChild } from '@angular/core';
import { Chunker } from '../framework/chunker';
import { UITableComponent } from '../framework/ui/table';
import { QARService, SystemRoleEntity, SystemRoleWithClashCountResult } from '../services/qar.service';
import { UIInputAutocompleterComponent } from '../framework/ui/input-autocompleter';

@Component({
	selector: 'app-page-sod-roles',
	templateUrl: 'system-roles.html',
	providers: [QARService]
})
export class SystemRolesPageComponent implements OnInit {

	constructor(public api: QARService) {
	}

	public self = this;

	@ViewChild('table', { static: false }) table: UITableComponent;
	@ViewChild('autocompleterRoles', { static: false }) autocompleterRoles: UIInputAutocompleterComponent;


	public ngOnInit(): void {
		this.roles_init();

	}

	public length(w) {
		return w && w.length ? w.length : 0;
	}

	public roles = {
		loadAuditLogs: false,
		auditLogs: [],
		auditLogsChunker: new Chunker([]),
		loadRoleBatchs: false,
		roleBatchs: [],
		roleBatchsChunker: new Chunker([]),
		all: [],
		unmappedCount: 0,
		chunker: (new Chunker([])),
		newClashRoleId: null,
		loading: false,
		selected: new SystemRoleWithClashCountResult(),
		selectedId: null,
		roles_clashes: [],
		saving: false,
		addingClash: false,
		deletingClashWith: {},
		clashesChunker: (new Chunker([])),
		clashes: [],
		clashesById: [],
		loadingClashes: false,
		chunkedData: [],
		tableHeaders: [
			{ id: 'SystemName', label: 'System', filterable: true, sortable: true },
			{ id: 'SystemRoleName', label: 'Role', filterable: true, sortable: true },
			{ id: 'SystemRoleMappedName', label: 'Standard Role Name', filterable: true, sortable: true },
			{ id: 'SystemRoleMappedDate', label: 'Mapped Date', filterable: true, type: 'date', sortable: true },
			{ id: 'SystemRoleMappedBy', label: 'Mapped By', filterable: true, sortable: true },
			{
				id: 'SystemRoleSODRequired',
				label: 'SOD Rule(s) Required?',
				filterable: true,
				sortable: true,
				type: 'dropdown',
				options: { choices: { na: 'not yet setup', y: 'required', n: 'not required' } },
				idFunction: this.roles_idFunctionSystemRoleRequired
			},
			{ id: 'ClashesCount', label: '# Rules', filterable: true, sortable: true },
			{
				label: 'Mapped?',
				filterable: true,
				sortable: true,
				filterValue: 'n',
				type: 'dropdown',
				options: { choices: { y: 'Mapped', n: 'Unmapped' }, emptyChoiceText: '(All)' },
				idFunction: this.roles_idFunctionSystemRoleMapped
			},
		],
		tableOptions: {
			refreshButton: true,
			onRefreshContext: this,
			onRefreshFunction: () => {
				this.roles_init();
			}
		}
	};

	public roles_alreadyClashing(id) {
		// console.log('this.roles.clashesById.indexOf(id)', this.roles.clashesById, id, this.roles.clashesById.indexOf(id) !== -1);
		return this.roles.clashesById.indexOf(id) !== -1;
	}

	public roles_idFunctionSystemRoleRequired(w) {
		if (w.SystemRoleSODRequired === null) {
			return 'na';
		}
		return w.SystemRoleSODRequired === true ? 'y' : 'n';
	}

	public roles_idFunctionSystemRoleMapped(w) {
		if (w.SystemRoleMappedName === null) {
			return 'n';
		} else if (w.SystemRoleMappedName) {
			return 'y';
		}
	}

	public roles_init(keepPagination = false) {
		this.roles.loading = true;

		const currentPage = this.table ? this.table.chunker.pagination.currentPage : 1;
		this.api.retrieveRolesWithClashCount().then(r => {
			this.roles.loading = false;
			this.roles.chunker = new Chunker(r);
			this.roles.all = r;
			this.roles.unmappedCount = 0;

			for (const role of r) {
				if (!role.SystemRoleMappedName)
					this.roles.unmappedCount++;
			}
			if (keepPagination) {
				setTimeout(() => {
					this.table.goToPage(currentPage);
					console.log('pagination', this.table);
				}, 100);

			}

		});
	}

	public roles_select(r: SystemRoleWithClashCountResult) {
		this.roles.selectedId = r.SystemRoleId;
		Object.assign(this.roles.selected, r);
		this.role_loadClashes();
		this.role_loadAuditLogs();
		this.role_loadBatchInfo();
	}

	public roles_remove() {
		this.roles.saving = true;

		this.api.updateRole(
			this.roles.selected.SystemRoleId,
			null,
			null, null, null).then(r => {
				this.roles.selected.SystemRoleMappedName = null;
				this.roles.selected.SystemRoleSODRequired = null;
				this.roles.selected.SystemRoleDescription = null;
				this.roles.saving = false;
				this.roles_init();
				this.role_loadAuditLogs();
			}, e => {
				this.roles.saving = false;
				console.error('e', { e: e, status: e.status });
				if (e.status === 409) {
					this.alert('You cannot un-map a role that is used in one or more SOD Clash rules', 'Warning');
				} else {
					this.alert('Sorry, it failed, please try again');
				}
			});
	}

	public roles_save() {
		if (this.roles.selected.SystemRoleSODRequired == null) {
			this.roles.selected.SystemRoleSODRequired = false;
		}
		if (!this.roles.selected.SystemRoleMappedName || this.roles.selected.SystemRoleMappedName.length < 3) {
			this.alert('Please enter a Standard Role Name','Warning');
			return;
		}
		this.roles.saving = true;
		console.log(this.roles.selected.SystemRoleId,
			this.roles.selected.SystemRoleSODRequired,
			this.roles.selected.SystemRoleMappedName);
		this.api.updateRole(
			this.roles.selected.SystemRoleId,
			this.roles.selected.SystemRoleSODRequired,
			this.roles.selected.SystemRoleMappedName,
			this.roles.selected.SystemRoleDescription,
			this.roles.selected.SystemRoleDeprecated,
		).then(r => {
			this.roles.saving = false;
			this.roles_init(true);
			this.role_loadAuditLogs();
		}, e => {
			this.roles.saving = false;
			console.error('e', e);
			if (e.status === 409) {
				this.alert('Standard Role Name is already in use by another role for this system','Warning');
			} else {
				this.alert('You cannot unmap a role that has SOD Roles clashing with this role', 'Warning');

			}
		});
	}

	public role_loadBatchInfo() {
		// load clashes
		this.roles.loadRoleBatchs = true;
		this.api.retrieveSystemRoleBatches(this.roles.selectedId).then(r => {
			this.roles.loadRoleBatchs = false;
			this.roles.roleBatchs = r;
			console.log(this.roles.roleBatchs);
		}, e => {
			this.roles.loadRoleBatchs = false;
			this.alert('Sorry, it failed, please try again');
		});
	}

	public role_loadClashes() {
		// load clashes
		this.roles.loadingClashes = true;
		this.api.retrieveRolesThatClashesWith(this.roles.selectedId).then(r2 => {
			this.roles.clashes = r2;
			this.roles.clashesById = [];
			// console.log('LOADED');
			for (const q of r2) {
				// console.log('q', q);
				this.roles.clashesById.push(q['ClashWithSystemRoleId']);
			}
			this.roles.clashesChunker = new Chunker(r2);
			this.roles.loadingClashes = false;
		}, e => {
			this.roles.loadingClashes = false;
			this.alert('sorry, could not load the clashes for this role, please refresh the page to try again');
		});
	}

	public role_addClash() {
		this.roles.newClashRoleId = this.autocompleterRoles.formControl.value['Id'];
		console.log('add clash to ' + this.roles.selectedId, this.roles.newClashRoleId, this.roles.selectedId === this.roles.newClashRoleId);

		if (parseInt(this.roles.selectedId, 0) === parseInt(this.roles.newClashRoleId, 0)) {
			if (!confirm('Role is clashing with itself, are you sure this is what you want to do?')) {
				return;
			}
		}


		if (!this.roles.newClashRoleId) {
			this.alert('Please select a role', 'Warning');
		} else {
			this.roles.addingClash = true;
			this.api.addClashToRole(this.roles.selectedId, this.roles.newClashRoleId).then(r => {
				this.roles.addingClash = false;
				this.role_loadClashes();
				this.roles.newClashRoleId = null;
				this.role_loadAuditLogs();
				this.roles_init();
			}, e => {
				this.roles.addingClash = false;
				this.alert('Sorry, it failed, please try again');
			});
		}
	}

	public roles_removeClashWith(r: any) {
		console.log('roles_removeClashWith', r);
		this.roles.deletingClashWith[r.ClashWithSystemRoleId] = true;
		this.api.removeClashToRole(this.roles.selectedId, r.ClashWithSystemRoleId).then(r2 => {
			this.roles.deletingClashWith[r.ClashWithSystemRoleId] = false;
			this.role_loadClashes();
			this.role_loadAuditLogs();
			this.roles_init();
		}, e => {
			this.roles.deletingClashWith[r.ClashWithSystemRoleId] = false;
			this.alert('Sorry, it failed, please try again');
		});
	}

	public role_autocompleteDisplaySelectedRole(option) {
		if (!option) {
			return '';
		}
		return option.System.Name + ' - ' + (option.MappedName ? option.MappedName : '') + ' (' + option.Name + ')';
	}

	public role_loadAuditLogs() {
		this.roles.loadAuditLogs = true;
		this.api.retrieveSystemRoleAuditLog(this.roles.selectedId).then(r => {
			this.roles.loadAuditLogs = false;
			this.roles.auditLogs = r;
			this.roles.auditLogsChunker = new Chunker(r);
		}, e => {
			this.roles.loadAuditLogs = false;
			this.alert('Sorry, it failed, please try again');
		});
	}

	public alert(text, title = 'Warning') {
		this.modalAlert.display = true;
		this.modalAlert.title = title;
		this.modalAlert.text = text;
		this.modalAlert.cb = (yesorno) => {
			this.modalAlert.display = false;
		};
	}

	public modalAlert = {
		display: false,
		title: '',
		text: '',
		cb: (yesorno) => {
		}
	};

	public search_roles(search) {
		return this.api.searchSystemRole(search);
	}

	public autocompleteDisplaySelectedRole(option: SystemRoleEntity) {
		if (!option) {
			return '';
		}
		return option.System.Name + ' - ' + (option.MappedName ? option.MappedName : '') + ' (' + option.Name + ')';
	}
}
